import type { UserRole, SubscriptionTier } from "@atsready/shared";
import { request } from "./api-client";
import type { PaginatedResponse, AdminUser, AdminUserDetail } from "./types";

export type { AdminUser, AdminUserDetail };

export async function listUsers(params?: {
  page?: number;
  pageSize?: number;
  search?: string;
  tier?: SubscriptionTier;
  role?: UserRole;
}): Promise<PaginatedResponse<AdminUser>> {
  const query = new URLSearchParams();
  if (params?.page) query.set("page", params.page.toString());
  if (params?.pageSize) query.set("pageSize", params.pageSize.toString());
  if (params?.search) query.set("search", params.search);
  if (params?.tier) query.set("tier", params.tier);
  if (params?.role) query.set("role", params.role);

  return request(`/users?${query.toString()}`);
}

export async function getUserById(id: string): Promise<{ data: AdminUserDetail }> {
  return request(`/users/${id}`);
}

export async function updateUser(
  id: string,
  data: { name?: string; role?: UserRole },
): Promise<{ data: AdminUserDetail }> {
  return request(`/users/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function disableUser(id: string, reason?: string): Promise<{ success: boolean }> {
  return request(`/users/${id}/disable`, {
    method: "POST",
    body: JSON.stringify({ reason }),
  });
}

export async function enableUser(id: string): Promise<{ success: boolean }> {
  return request(`/users/${id}/enable`, {
    method: "POST",
  });
}

export async function getUserActivity(
  id: string,
  params?: { page?: number; pageSize?: number },
): Promise<PaginatedResponse<{ id: string; action: string; createdAt: string }>> {
  const query = new URLSearchParams();
  if (params?.page) query.set("page", params.page.toString());
  if (params?.pageSize) query.set("pageSize", params.pageSize.toString());

  return request(`/users/${id}/activity?${query.toString()}`);
}
